import { useRef } from 'react'
import FinanceExplained from './components/finance-explained/finance-explained'
import FinanceLenders from './components/finance-lenders/finance-lenders'
import FindACarCta from './components/find-a-car-cta/find-a-car-cta'
import FindACar from './components/find-a-car/find-a-car'
import HowItWorks from './components/how-it-works/how-it-works'
import ReadyToGetCarFinance from './components/ready-to-get-car-finance/ready-to-get-car-finance'
import TrustpilotScore from './components/trustpilot-score/trustpilot-score'
import UnderstandCarFinance from './components/understand-car-finance/understand-car-finance'
import CarFinanceHead from './components/head/head'
import { CarFinancePageProps } from './get-static-props'
import { carFinancePageText } from './locales/index'
import { useTrustpilotScore } from '@cinch-nx/data-trustpilot'
import { Env, readFromEnv } from '@cinch-nx/environments'
import { TrustpilotScoreless } from '@cinch-nx/shared-ui'
import styles from './feature-car-finance.module.css'

export function FeatureCarFinance({ trustpilotData }: CarFinancePageProps) {
  const findACarRef = useRef(null)

  const cinchStarRating = useTrustpilotScore()

  const showTrustPilot = readFromEnv(Env.CarFinanceShowTrustPilot) === 'true'
  const showTrustPilotScoreless =
    readFromEnv(Env.ShowScorelessTrustpilot) === 'true'

  const showTruspilotScoreless = cinchStarRating
    ? showTrustPilotScoreless || cinchStarRating <= 4.2
    : showTrustPilotScoreless

  return (
    <>
      <CarFinanceHead
        fallbackTitle={carFinancePageText.carFinanceHeadText.fallbackTitle}
        fallbackDescription={
          carFinancePageText.carFinanceHeadText.fallbackDescription
        }
      />
      <FindACarCta
        i18n={carFinancePageText.findACarCta}
        triggerPointRef={findACarRef}
      />

      {showTrustPilot && trustpilotData && (
        <div className={styles.trustPilotWrapper}>
          {showTruspilotScoreless ? (
            <TrustpilotScoreless
              shouldShowFirstLine={false}
              numberOfReviews={trustpilotData.totalReviews}
            />
          ) : (
            <TrustpilotScore
              numberOfReviews={trustpilotData.totalReviews}
              starRatingLabel={trustpilotData.starRatingLabel}
              starRating={trustpilotData.starRating}
            />
          )}
        </div>
      )}
      <HowItWorks i18n={carFinancePageText.howItWorks} />
      <div ref={findACarRef}>
        <FindACar i18n={carFinancePageText.findACar} />
      </div>
      <FinanceExplained i18n={carFinancePageText.financeExplained} />
      <UnderstandCarFinance i18n={carFinancePageText.understandCarFinance} />
      <FinanceLenders i18n={carFinancePageText.lenderPartners} />
      <ReadyToGetCarFinance i18n={carFinancePageText.readyToGetCarFinance} />
    </>
  )
}

export default FeatureCarFinance
